import type { KeyboardEvent } from 'react';
import type { FrameItem } from '../../doc/schema';
import { useBoard, usePane, usePaneStore } from '../context';

/**
 * Frame body: a labelled outline. The interior lets pointer events through (so items inside
 * and the canvas behind stay clickable); the label and the edges pick the frame itself.
 */
export function FrameBody({ item }: { item: FrameItem }) {
  const editing = usePane((s) => s.editingId === item.id);
  const pane = usePaneStore();
  const board = useBoard();
  const color = item.props.color;
  const style = color ? ({ '--frame-color': color } as React.CSSProperties) : undefined;

  const commit = (title: string) => {
    if (title !== item.props.title) board.updateItem(item.id, { props: { title } });
    pane.getState().setEditing(null);
  };
  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (e.key === 'Escape' || e.key === 'Enter') e.currentTarget.blur();
  };

  return (
    <div className="frame-body" style={style}>
      <div className="frame-edge frame-edge-t" />
      <div className="frame-edge frame-edge-r" />
      <div className="frame-edge frame-edge-b" />
      <div className="frame-edge frame-edge-l" />
      {editing ? (
        <input
          className="frame-title frame-title-editor"
          defaultValue={item.props.title}
          autoFocus
          spellCheck={false}
          onPointerDown={(e) => e.stopPropagation()}
          onKeyDown={onKeyDown}
          onBlur={(e) => commit(e.currentTarget.value.trim())}
          onFocus={(e) => e.currentTarget.select()}
        />
      ) : (
        <div className="frame-title">{item.props.title || 'Frame'}</div>
      )}
    </div>
  );
}
